import React, {Component} from 'react';
import { connect} from 'react-redux'
import {bindActionCreators, compose} from 'redux'
import CTable from '@/components/CTable'
import CBaseComponent from '@/components/CBaseComponent'
import { setReload } from "@/redux/common/action";
import { tableData} from './data'
import './index.scss'
import {getFujianList} from "../../../../servers/province";
import {withRouter} from "react-router-dom";
import store from "../../../../redux";
import {refreshMenu} from "../../../../redux/common/action";
@CBaseComponent
class GoodsManageList extends Component{
  constructor(props) {
    super(props);
    this.getListData = this.getListData.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    // reload时重新加载数据
    // this.getListData();
  }


  state = {
    columns: tableData.tHead,
    dataSource: tableData.tBody,
    page: tableData.tPage,
    loading: false,
    museumid:''
  };

  // 获取用户列表数据
  getListData(){
    this.setState({
      loading: true
    });
    const result = JSON.parse(localStorage.getItem('userList'))
    const year = JSON.parse(localStorage.getItem('year'))
    const params = {
      museumid:this.state.museumid,
      annual:year
    }
    getFujianList(params).then(res=>{
      if (res.records.length>0){
        let data =JSON.parse(JSON.stringify(res.records))
        let total = 1;
        this.setState({
          dataSource: data[0].datalist,
          page: {...this.state.page, total},
          loading: false
        });
      } else {
        this.setState({
          loading: false
        });
      }

    }).catch(err=>{
      console.log(err,'rttt')
    })
  }

  componentWillUnmount() {
    // 在组件卸载时取消订阅
    if (this.unsubscribe) this.unsubscribe();
  }


  componentDidMount(){
    const result = JSON.parse(localStorage.getItem('userList'))
    if (result.clerklevel === 8 || result.clerklevel === 9){
      this.setState({
        museumid:result.museumid,
      },()=>{
        this.getListData()
      })
    } else {
      this.setState({
        museumid:store.getState().libraryid
      },()=>{
        this.getListData()
      })
    }

    let currentState = store.getState();
    this.unsubscribe = store.subscribe(() => {
      let previousState = currentState;
      currentState = store.getState();
      if (previousState.libraryid !== currentState.libraryid) {
        this.getListData()
        this.props.refreshMenu(true)
      }
      if (previousState.year !== currentState.year) {
        this.getListData()
        this.props.refreshMenu(true)
      }
    })

  }
  render(){
    return (
        <div className='user-manage-list fujian'>
          <CTable ref='userManageList' checked={false} loading={this.state.loading} columns={this.state.columns} dataSource={this.state.dataSource} onTableChange={this.onTableChange}>
            <div
                slot='t1'
                render={(text, record, index) => (
                    <div className='t1'>
                      {record[0]}
                    </div>
                )} />
            <div
                slot='t2'
                render={(text, record, index) => (
                    <div className='operate'>
                      {record[1]}
                    </div>
                )} />
            <div
                slot='t3'
                render={(text, record, index) => (
                    <div className='operate'>
                      {record[2]}
                    </div>
                )} />
            <div
                slot='t4'
                render={(text, record, index) => (
                    <div className='t1'>
                      {record[3]}
                    </div>
                )} />
            <div
                slot='t5'
                render={(text, record, index) => (
                    <div className='operate'>
                      {record[4]}
                    </div>
                )} />
            <div
                slot='t6'
                render={(text, record, index) => (
                    <div className='operate'>
                      {record[5]}
                    </div>
                )} />
          </CTable>
        </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    reload: state.reload,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    setReload: bindActionCreators(setReload, dispatch),
    refreshMenu: bindActionCreators(refreshMenu, dispatch),
  }
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(GoodsManageList);
